export function Exercisetracker(Profile, $rootScope, $q, UserService) {


  var _exercises;
  var _exercisetracker;
  // weights (in ib) from db
  var w1 = 130,w2 = 155,w3 = 180,w4 = 201;
  var Exercisetracker = {
    getExercises: getExercises,
    getExerciseTrackers: getExerciseTrackers,
    trackExercise: trackExercise,
    untrackExercise: untrackExercise };



  return Exercisetracker;

  function getExercises() {
    if (_exercises) {
      var ret = $q.resolve(angular.copy(_exercises));
      return ret;
    } else
    {
      var req = Profile.getExercises().then(function (res) {
        _exercises = res.data;
        return angular.copy(_exercises);
      });
      return req;
    }
  }

  function _calculateCalories(exercise, weight) {
    var mins = parseInt(exercise.mins);
    if (weight < w1) {
      var cal = weight * exercise.ib130 / w1;
    } else
    if (weight >= w1 && weight < w2) {
      var cal = weight * exercise.ib155 / w2;
    } else
    if (weight >= w2 && weight < w4) {
      var cal = weight * exercise.ib180 / w3;
    } else
    if (weight >= w4) {
      var cal = weight * exercise.ib201 / w4;
    }
    cal = parseInt(cal * mins / 60);
    return cal;
  }

  function getExerciseTrackers() {
    if (!_exercisetracker) {
      if (UserService.data.id) {
        var oFilters = {
          week: UserService.data.last_checkin.week_number,
          day: UserService.data.last_checkin.day,
          checkin: UserService.data.last_checkin.id };

        var req = Profile.getExerciseTrackers(oFilters).then(function (res) {
          // if there are exercise trackers take the first one
          if (res.data.length) {
            _exercisetracker = res.data[0];
            return angular.copy(_exercisetracker);
            // if not exercise trackers go create one for today
          } else {
            return createExerciseTracker();
          }
        });
        return req;
      }
    } else

    return $q.resolve(angular.copy(_exercisetracker));
  }

  function createExerciseTracker() {
    var oExerciseTracker = {
      week: UserService.data.last_checkin.week_number,
      day: UserService.data.last_checkin.day,
      checkin: UserService.data.last_checkin.id };

    var req = Profile.createExerciseTracker(oExerciseTracker).then(getExerciseTrackers);
    return req;
  }

  function trackExercise(exercise, weight) {
    var cal = _calculateCalories(exercise, weight);
    var mins = parseInt(exercise.mins);
    _exercisetracker.total_minutes += mins;
    _exercisetracker.total_calories += cal;

    var obj = {
      exercise: exercise.id,
      tracker: _exercisetracker.id,
      minutes: mins,
      cal: cal };


    var req = Profile.createLoggedExercise(obj).then(function (res) {
      obj.id = res.data.id;
      obj.title = exercise.title;
      _exercisetracker.logged_exercises.push(obj);
      var data = { cal: cal, exercisetracker: angular.copy(_exercisetracker) };
      return data;
    });

    return req;
  }

  function untrackExercise($index) {
    var exercise = _exercisetracker.logged_exercises[$index];
    var req = Profile.destroyLoggedExercise(exercise).then(function (res) {
      _exercisetracker.total_minutes -= exercise.minutes;
      _exercisetracker.total_calories -= exercise.cal;
      _exercisetracker.logged_exercises.splice($index, 1);
      return angular.copy(_exercisetracker);
    });
    return req;
  }
}